import React, { useEffect, useRef, useState } from 'react'
import { GrMoreVertical } from "react-icons/gr";
import Pagination from "../../components/pagination/pagination";
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../components/button/button';
import { teamDeleteAction, teamListAction } from '../../redux/actions/teamAction';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import moment from 'moment';
import successToast from '../../components/toasts/successToast';
import { useAuth } from '../../context/AuthContext';

export const Teams = () => {
    const [data, setData] = useState([]);
    const [teamName, setTeamName] = useState("");
    const [teamLead, setTeamLead] = useState("");
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("");
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationData, setPaginationData] = useState({});
    const [showOptions, setShowOptions] = useState(false);
    const [showClearIndex, setShowClearIndex] = useState(null);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isAdmin } = useAuth();

    const handleApplyFilters = () => {
        setLoading(true);
        setFiltersApplied(true); // Show the table after filters are applied
        dispatch(teamListAction({
            page,
            page_size: rowsPerPage,
            name: teamName,
            team_lead: teamLead,
            from_date: startDate,
            to_date: endDate,
        }, onSuccess, onError));
    };

    // Function to fetch all records without filters
    const handleGetAllRecords = () => {
        setLoading(true);
        setTeamName('');
        setTeamLead('')
        setStartDate('');
        setEndDate('');
        setFiltersApplied(true); // Show the table
        dispatch(teamListAction({ page, page_size: rowsPerPage }, onSuccess, onError)); // No filters
    };

    const handleClear = () => {
        setLoading(false);
        setTeamName('');
        setTeamLead('')
        setStartDate('');
        setEndDate('');
        setFiltersApplied(false);
    };

    useEffect(() => {
        if (filtersApplied) {
            setLoading(true);
            dispatch(teamListAction({
                page,
                page_size: rowsPerPage,
                name: teamName,
                team_lead: teamLead,
                from_date: startDate,
                to_date: endDate,
            }, onSuccess, onError));
        }
    }, [page, rowsPerPage, filtersApplied, teamName, teamLead, startDate, endDate, dispatch]);


    const onSuccess = (data) => {
        setPaginationData(data?.data?.data?.pagination);
        setData(data?.data?.data?.teams);
        setLoading(false);
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    const handleMoreOptionsClick = (item, index) => {
        setShowClearIndex(index);
        setShowOptions(!showOptions);
    };

    const handleDeleteClick = (id) => {
        setLoading(true);
        dispatch(teamDeleteAction({ id }, onDeleteSuccess, onError));
    };

    const onDeleteSuccess = (data) => {
        dispatch(teamListAction({
            page,
            page_size: rowsPerPage,
            name: teamName,
            team_lead: teamLead,
            from_date: startDate,
            to_date: endDate,
        }, onSuccess, onError));
        setShowOptions(false);
        setShowClearIndex(null);
        successToast(data?.data?.message);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowOptions(false);
            setShowClearIndex(null);
        }
    };

    /* ── Access guard ── */
    if (!isAdmin) {
        return (
            <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <i className="bi bi-shield-lock fs_40 text-danger mb-3"></i>
                <h5 className="fw_600">Access Denied</h5>
                <p className="text-muted fs_14">This page is only accessible to company administrators.</p>
            </div>
        );
    }

    return (
        <div className="d-flex vh-100 overflow-auto" onClick={handleClickOutside} >
            <div className="w-100">
                <div className="w-100 z-1 header align-items-center border-bottom  d-flex position-sticky top-0 bg-white py-2 justify-content-between">
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">Teams</h2>
                    {isAdmin &&
                        <CustomButton className='cursor_pointer fs_18 pb-1 mx-3 d-flex align-items-center justify-content-center' style={{ height: '35px', width: '115px' }} variant='primary' onClick={() => navigate('/add-team')}>Add Team +</CustomButton>
                    }
                </div>

                <div className='d-flex flex-wrap gap-3 p-3'>
                    <div className='text-start'>
                        <span className="">Team Name</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='text'
                                name='team_name'
                                className='input-field w-100'
                                placeholder="Enter team name"
                                value={teamName}
                                onChange={(e) => setTeamName(e.target.value)}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                }}
                            />
                        </div>
                    </div>

                    <div className='text-start'>
                        <span className="">Team Lead</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='text'
                                name='team_lead'
                                className='input-field w-100'
                                placeholder="Enter team lead"
                                value={teamLead}
                                onChange={(e) => setTeamLead(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className='text-start'>
                        <span className="">From Date</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='date'
                                name='startDate'
                                className='input-field w-100'
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                max={new Date().toISOString().split('T')[0]}
                            />
                        </div>
                    </div>

                    <div className='text-start'>
                        <span className="">To Date</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='date'
                                name='endDate'
                                className='input-field w-100'
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                max={new Date().toISOString().split('T')[0]}
                            />
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-start gap-3 mx-3 pt-1 text-nowrap">
                    <CustomButton variant="primary" onClick={handleApplyFilters} disabled={!teamLead && !teamName && !startDate && !endDate} >
                        Apply Filters
                    </CustomButton>
                    <CustomButton variant="primary" onClick={handleGetAllRecords}>
                        Show All
                    </CustomButton>
                    <CustomButton variant="secondary" onClick={handleClear}>
                        Clear Filters
                    </CustomButton>
                </div>

                {filtersApplied && (
                    <>
                        <div className="m-3 " >
                            {/* <div className="input-group mb-3">
                        <span className="input-group-text gap-3">
                            <LuSearch />
                            Search
                        </span>
                        <input
                            type="text"
                            className="input-field w-75"
                            placeholder="Enter team name"
                            value={filterTerm}
                            onChange={(e) => setFilterTerm(e.target.value)}
                        />
                    </div> */}
                            <div className="table-responsive  overflow-auto" style={{ minHeight: '26rem', minWidth: '100%' }}>
                                <table className="table table-bordered" >
                                    <thead className="table-light">
                                        <tr className="text-start text-nowrap">
                                            <th width={'8%'} className='fw_400'>Sl No.</th>
                                            <th width={'18%'} className='fw_400'>Team Name</th>
                                            <th width={'20%'} className='fw_400'>Team Lead</th>
                                            <th width={'18%'} className='fw_400'>Team Size</th>
                                            <th width={'18%'} className='fw_400'>Created Date</th>
                                            {isAdmin && <th width={'3%'} className='fw_400'></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr >
                                                <td colSpan="7">
                                                    Loading...
                                                </td>
                                            </tr>
                                        ) : data?.length > 0 ? (
                                            data?.map((item, index) => (
                                                <tr key={index} className='text-start'>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <a href={`/team-view/${item.id}`} className='cursor_pointer text-decoration-none' >
                                                            {item?.name}
                                                        </a>
                                                    </td>
                                                    <td>{item?.teamLead?.email}</td>
                                                    <td>{item?.teamUsers?.length}</td>
                                                    <td>{moment(item?.createdAt).format('MM/DD/YY, hh:mm A')}</td>
                                                    {isAdmin &&
                                                        <td className='px-4'>
                                                            <GrMoreVertical
                                                                className="cursor_pointer"
                                                                onClick={() => handleMoreOptionsClick(item, index)}
                                                            />
                                                            {showOptions && showClearIndex === index && (
                                                                <div className="position-relative" ref={dropdownRef}>
                                                                    <div className="position-absolute" style={{ left: "-5rem" }}>
                                                                        <div className="card" style={{ width: '5rem' }}>
                                                                            <div className="card-body p-2">
                                                                                <label className="d-block text-danger cursor_pointer hover-effect" onClick={() => { handleDeleteClick(item.id) }}>Delete</label>
                                                                                <label className="d-block cursor_pointer hover-effect" onClick={() => { navigate(`/team-view/${item.id}`) }}>View</label>
                                                                                <label className="d-block cursor_pointer hover-effect" onClick={() => { navigate(`/edit-team/${item.id}`) }}>Edit</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </td>
                                                    }
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7">No rows to display</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="p-4 d-flex justify-content-end ">
                            {!loading &&
                                <Pagination
                                    data={paginationData}
                                    nextFunc={() => setPage(page + 1)}
                                    prevFunc={() => setPage(page - 1)}
                                    setPageRowFunc={(value) => {
                                        setPage(1);
                                        setRowsPerPage(value);
                                    }}
                                />
                            }
                        </div>
                    </>
                )}

            </div >
        </div >
    )
}